import React from "react";
import { observer, inject } from 'mobx-react';
// core components
import config from 'config';
import Tooltip from "@material-ui/core/Tooltip";
import GetApp from "@material-ui/icons/GetApp";
import BurstModeIcon from '@material-ui/icons/BurstMode';
import EventAvailable from "@material-ui/icons/EventAvailable";
import EditIcon from '@material-ui/icons/Edit';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Badge from "components/Badge/Badge.jsx";
import moment from 'moment';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Link } from "react-router-dom";
import auth from 'utils/auth';

class BoxVdo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      videoUrl: '',
    };
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  handleClickOpen = (url) => {
    this.setState({ videoUrl: url });
    this.setState({ open: true });
  };

  downloadThumb = async (thumbnails, url) => {
    await this.props.media.downloadThumb(thumbnails, url);
  }

  downloadVDO = async (api, url) => {
    await this.props.media.downloadVDO(api, url);
  }

  goTo = (url) => {
    this.props.history.push(url);
  }


  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const { classes, data } = this.props;
    const fileName = data.url.replace('https://s3-ap-southeast-1.amazonaws.com/nw-fast-media/media/', '');
    return (
      <GridItem xs={12} sm={6} md={3} lg={2}>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">
            {'Video'}
          </DialogTitle>
          <DialogContent>
            <video width="100%" controls>
              <source src={this.state.videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
          </video>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="danger" autoFocus>
              Close
        </Button>
          </DialogActions>
        </Dialog>
        <Card product className={classes.cardHover}>
          <CardHeader image className={classes.cardHeaderHover}>
            <Link
              to={`/admin/media/${data.id}/view`}
            >
              {/* <a href="#" onClick={() => { this.handleClickOpen(data.url) }} > */}
              <img src={data.thumbnail} alt="..." />
              {/* </a> */}
            </Link>
          </CardHeader>
          <CardBody>
            <div className={classes.cardHoverUnder}>
              <Tooltip
                id="tooltip-top"
                title="Play"
                placement="bottom"
                classes={{ tooltip: classes.tooltip }}
              >
                <Button color="danger" simple justIcon onClick={() => { this.handleClickOpen(data.url) }}>
                  <PlayCircleOutlineIcon className={classes.underChartIcons} />
                </Button>
              </Tooltip>
              <Tooltip
                id="tooltip-top"
                title="Download VDO"
                placement="bottom"
                classes={{ tooltip: classes.tooltip }}
              >
                <Button color="success" simple justIcon onClick={e => this.downloadVDO(`${config.s3.url}/api/files/${fileName}`, data.url)}>
                  {/* <a href={`${config.s3.url}/api/files/${fileName}`} download> */}
                  <GetApp className={classes.underChartIcons} />
                  {/* </a> */}
                </Button>
              </Tooltip>
              <Tooltip
                id="tooltip-top"
                title="Download Thumbnails"
                placement="bottom"
                classes={{ tooltip: classes.tooltip }}
              >
                <Button color="primary" simple justIcon onClick={e => this.downloadThumb(data.thumbnails, data.url)}>
                  <BurstModeIcon className={classes.underChartIcons} />
                </Button>
              </Tooltip>
              { (auth.getUserRole() === 'super_admin') &&
                            <Tooltip
                id="tooltip-top"
                title="Edit"
                placement="bottom"
                classes={{ tooltip: classes.tooltip }}
              >
                <Button color="warning" simple justIcon onClick={e => this.goTo(`/admin/media/${data.id}/edit`)}>
                  <EditIcon className={classes.underChartIcons} />
                </Button>
              </Tooltip>
              }

            </div>
            <div className={classes.cardProductTitle}>
              {data.name}
            </div>
            <p className={classes.cardProductDesciprion}>
              <Badge color='info'>
                {data.category.map((val, key) => {
                  return key > 0 ? `/${val.name}` : val.name
                })}
              </Badge>
            </p>

          </CardBody>
          <CardFooter product>
            <div className={`${classes.stats} ${classes.productStats}`}>
              <EventAvailable /> {moment(data.start_date).format("DD-MM-YYYY")}
            </div>
          </CardFooter>
        </Card>
      </GridItem>
    );
  }
}

export const page = inject('media')(observer(BoxVdo));
export default withStyles(dashboardStyle, { withTheme: true })(page);
